import { render, staticRenderFns } from "./AuthenticatedLayout.vue?vue&type=template&id=ae04a7fc&scoped=true"
import script from "./AuthenticatedLayout.vue?vue&type=script&lang=js"
export * from "./AuthenticatedLayout.vue?vue&type=script&lang=js"
import style0 from "./AuthenticatedLayout.vue?vue&type=style&index=0&id=ae04a7fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae04a7fc",
  null
  
)

export default component.exports